module.exports = __webpack_public_path__ + "img/travel_black_icon.798fef8b.svg";